import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "PromoContainer" */ './container/PromoContainer'));
